import React from "react";

export default function DatosActaHtml({ datosActa }) {
    const containerStyle = { maxWidth: 900, margin: "auto", fontFamily: "Helvetica,Arial,sans-serif", fontSize: 14 };
    const centerTextStyle = { textAlign: "center" };
    const logoStyle = { height: 40, margin: "20px 0" };
    const marginTop20 = { marginTop: 20 };
    const margin15 = { margin: "15px 0" };
    return (
        <div style={containerStyle}>
            <div style={centerTextStyle}>
                <img src="/dist/img/alcaldialogo.jpg" alt="Logo" style={logoStyle} />
                <h2 style={{ margin: 0 }}>
                    {datosActa.formularioactaentrega.find(t => t.camNombrecampo === "titulo1")?.camValorcampo}
                </h2>
                <div style={{ fontWeight: "bold" }}>
                    {datosActa.formularioactaentrega.find(t => t.camNombrecampo === "titulo2")?.camValorcampo}
                </div>
            </div>
            <div style={marginTop20}>
                <div>
                    <b>{datosActa.formularioactaentrega.find(t => t.camNombrecampo === "fecha")?.camValorcampo}:</b> {datosActa.encabezado?.fecha?.split('T')[0]}
                </div>
                <div>
                    <b>{datosActa.formularioactaentrega.find(t => t.camNombrecampo === "documento")?.camValorcampo}:</b> {datosActa.encabezado?.idpersona}
                </div>
                <div>
                    <b>{datosActa.formularioactaentrega.find(t => t.camNombrecampo === "nombre")?.camValorcampo}:</b> {datosActa.encabezado?.nombre}
                </div>
                <div>
                    <b>{datosActa.formularioactaentrega.find(t => t.camNombrecampo === "componente")?.camValorcampo}:</b> {datosActa.formularioactaentrega.find(t => t.camNombrecampo === "componentenombre")?.camValorcampo}
                </div>
                <div>
                    <b>{datosActa.formularioactaentrega.find(t => t.camNombrecampo === "entrega")?.camValorcampo}:</b> {datosActa.encabezado?.entrega}
                </div>
                <div style={margin15}>
                    {datosActa.formularioactaentrega.find(t => t.camNombrecampo === "textocontratos")?.camValorcampo}
                </div>
            </div>
            <table style={{ width: "100%", marginTop: 20, borderCollapse: "collapse" }}>
                <thead>
                    <tr style={{ background: "#eee" }}>
                        <th style={{ border: "1px solid #ccc", padding: 4 }}>Cantidad</th>
                        <th style={{ border: "1px solid #ccc", padding: 4 }}>Descripción</th>
                        <th style={{ border: "1px solid #ccc", padding: 4 }}>Valor unitario</th>
                        <th style={{ border: "1px solid #ccc", padding: 4 }}>Valor</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(datosActa.datosacta) && datosActa.datosacta.length > 0 ? (
                        datosActa.datosacta.map((item) => (
                            <tr key={item.id || item.ayuda || JSON.stringify(item)}>
                                <td style={{ border: "1px solid #ccc", padding: 4 }}>{item.cantidad}</td>
                                <td style={{ border: "1px solid #ccc", padding: 4 }}>{item.ayuda}</td>
                                <td style={{ border: "1px solid #ccc", padding: 4 }}>${" "}{item.valor}</td>
                                <td style={{ border: "1px solid #ccc", padding: 4 }}>${" "}{item.valor}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={4} style={{ textAlign: "center", border: "1px solid #ccc", padding: 4 }}>No hay datos</td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={3} style={{ textAlign: "right", border: "1px solid #ccc", padding: 4 }}><b>Total:</b></td>
                        <td style={{ border: "1px solid #ccc", padding: 4 }}><b>${datosActa.encabezado?.valor}</b></td>
                    </tr>
                </tfoot>
            </table>
            <div style={{ marginTop: 20 }}>
                <b>{datosActa.formularioactaentrega.find(t => t.camNombrecampo === "operador")?.camValorcampo}</b>
            </div>
        </div>
    )
}